module.exports = __webpack_public_path__ + "static/media/collage-logo-big.f2b9a44d.png";